import React, { useEffect, useState } from 'react'
import {
  ModernModalBackdrop,
  ModernVerticalModal,
  ModalFieldGroup,
  ModalLabel,
  ModalInput,
  ModalSelect,
  SubmitButton,
} from '../../../styles/Modal'
import { IoCloseCircleSharp } from 'react-icons/io5'
import { carregarMarcas, MarcaItem } from '../../../services/marcas'
import { carregarDistribuidores } from '../../../services/dists'
import DistMultipleSelector from '../../Common/DistMultipleSelector'
import MarcaMultipleSelector from '../../Common/MarcaMultipleSelector'

interface InfoUser {
  name: string
  setName: (text: string) => void
  email: string
  setEmail: (text: string) => void
  password: string
  setPassword: (text: string) => void
  nickname: string
  phone: string
  setPhone: (text: string) => void
  status: number
  setStatus: (text: number) => void
  loading: boolean
  handlePhoneChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleClick: () => void
  setCloseModal: () => void
  role?: string
  vincMarca?: string
  setVincMarca?: (text: string) => void
  vincDist?: string | number
  setVincDist?: (text: any) => void
  distGestor?: number | string
  setDistGestor?: (distId: any) => void
  distsVisualizador?: number[]
  setDistsVisualizador?: (ids: number[]) => void
}

function ModalUserEdit({
  email,
  password,
  name,
  nickname,
  phone,
  loading,
  status,
  setStatus,
  setName,
  setEmail,
  setPassword,
  handleClick,
  handlePhoneChange,
  setCloseModal,
  role,
  vincMarca,
  setVincMarca,
  vincDist,
  setVincDist,
  distGestor,
  setDistGestor,
  distsVisualizador = [],
  setDistsVisualizador,
}: InfoUser) {
  const [marcasList, setMarcasList] = useState<MarcaItem[]>([])
  const [distsList, setDistsList] = useState<any[]>([])

  useEffect(() => {
    carregarDistribuidores().then((res) => setDistsList(res))
    if (role === 'conferente') {
      carregarMarcas().then((res) => setMarcasList(res))
    }
  }, [role])

  return (
    <ModernModalBackdrop>
      <ModernVerticalModal style={{ maxWidth: '560px' }}>
        <div className="header">
          <h3>Editar Usuário</h3>
          <button className="btn-close" onClick={setCloseModal} type="button">
            <IoCloseCircleSharp />
          </button>
        </div>

        <div className="body" style={{ maxHeight: '82vh', overflowY: 'auto' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              background: 'rgba(255,255,255,0.03)',
              padding: '12px 16px',
              borderRadius: '12px',
              border: '1px solid rgba(255,255,255,0.05)',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '44px',
                height: '44px',
                borderRadius: '50%',
                background:
                  role === 'administrador'
                    ? 'linear-gradient(135deg, #f59e0b, #d97706)'
                    : role === 'conferente'
                    ? 'linear-gradient(135deg, #ec4899, #be185d)'
                    : role === 'visualizador'
                    ? 'linear-gradient(135deg, #a855f7, #7e22ce)'
                    : 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                color: '#ffffff',
                fontWeight: 800,
                fontSize: '15px',
              }}
            >
              {nickname ? nickname.slice(0, 2).toUpperCase() : 'U'}
            </div>
            <div>
              <p
                style={{
                  fontSize: '11px',
                  color: '#94a3b8',
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  margin: '0 0 2px 0',
                }}
              >
                Perfil: <strong style={{ color: '#ffffff' }}>{role}</strong>
              </p>
              <h4 style={{ color: '#ffffff', fontSize: '15px', fontWeight: 700, margin: 0 }}>@{nickname}</h4>
            </div>
          </div>

          <ModalFieldGroup>
            <ModalLabel>Nome Completo</ModalLabel>
            <ModalInput
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Digite o nome completo"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Alterar Senha</ModalLabel>
            <ModalInput
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Digite a nova senha se desejar alterar"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>E-mail</ModalLabel>
            <ModalInput
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Ex: usuario@grupogsa.com.br"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Telefone</ModalLabel>
            <ModalInput
              type="text"
              value={phone}
              onChange={handlePhoneChange}
              maxLength={15}
              placeholder="(00) 00000-0000"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Status do Usuário</ModalLabel>
            <ModalSelect
              value={status}
              onChange={(e) => setStatus(Number(e.target.value))}
            >
              <option value="">Selecione o status</option>
              <option value={1}>Ativo</option>
              <option value={0}>Inativo</option>
            </ModalSelect>
          </ModalFieldGroup>

          {/* Vínculo 1: GESTOR (Distribuidor Único) */}
          {role === 'gestor' && setDistGestor && (
            <ModalFieldGroup>
              <ModalLabel>Distribuidor Vinculado ao Gestor</ModalLabel>
              <ModalSelect
                value={distGestor || ''}
                onChange={(e) => setDistGestor(e.target.value ? Number(e.target.value) : '')}
              >
                <option value="">Nenhum Distribuidor Vinculado</option>
                {distsList.map((d) => (
                  <option key={d.id} value={d.id}>
                    {d.name || d.fantasy_name} {d.cnpj ? `(CNPJ: ${d.cnpj})` : ''}
                  </option>
                ))}
              </ModalSelect>
            </ModalFieldGroup>
          )}

          {/* Vínculo 2: VISUALIZADOR (Múltiplos Distribuidores) */}
          {role === 'visualizador' && setDistsVisualizador && (
            <ModalFieldGroup>
              <DistMultipleSelector
                dists={distsList}
                selectedIds={distsVisualizador}
                onChange={setDistsVisualizador}
                label="Distribuidores Autorizados para Consulta"
              />
            </ModalFieldGroup>
          )}

          {/* Vínculo 3: CONFERENTE (Múltiplas Marcas sem cod_cat + Múltiplos Distribuidores) */}
          {role === 'conferente' && setVincMarca && (
            <ModalFieldGroup>
              <MarcaMultipleSelector
                marcas={marcasList}
                selectedMarcas={
                  vincMarca ? vincMarca.split(',').map((s) => s.trim()).filter(Boolean) : []
                }
                onChange={(newMarcas) => setVincMarca(newMarcas.join(','))}
                label="Marcas Permitidas"
              />
              <span style={{ fontSize: '11px', color: '#94a3b8' }}>
                {!vincMarca
                  ? 'Nenhuma marca selecionada: o conferente terá acesso a todas as marcas.'
                  : `Marcas selecionadas: ${vincMarca}`}
              </span>
            </ModalFieldGroup>
          )}

          {role === 'conferente' && setVincDist && (
            <ModalFieldGroup>
              <DistMultipleSelector
                dists={distsList}
                selectedIds={
                  vincDist
                    ? String(vincDist)
                        .split(',')
                        .map((s) => Number(s.trim()))
                        .filter((n) => !isNaN(n) && n > 0)
                    : []
                }
                onChange={(newIds) => setVincDist(newIds.length > 0 ? newIds.join(',') : '')}
                label="Distribuidores Permitidos"
              />
              <span style={{ fontSize: '11px', color: '#94a3b8' }}>
                {!vincDist
                  ? 'Nenhum distribuidor selecionado: o conferente poderá ver todos os distribuidores.'
                  : 'Distribuidores específicos com acesso concedido ao conferente.'}
              </span>
            </ModalFieldGroup>
          )}

          <SubmitButton type="button" onClick={handleClick} disabled={loading}>
            {loading ? 'Carregando...' : 'Salvar Alterações'}
          </SubmitButton>
        </div>
      </ModernVerticalModal>
    </ModernModalBackdrop>
  )
}

export default ModalUserEdit
